// extracted by mini-css-extract-plugin
module.exports = {"container":"avm_e","icon":"avm_b8","text":"avm_jv"};